<template>
  <div class="container">
    <el-backtop :right="50" :bottom="50"></el-backtop>
    <div class="headerImg">
      <div class="mainTitle">{{ title }}</div>
    </div>
    <div class="main-top">
      <img
        src="@/assets/fhsy.png"
        style="width:105px;height:32px"
        @click="$router.push({path:'/'})"
        class="point"
      />
    </div>
    <div class="main">
      <div class="news-dt">{{detailInfo.title}}</div>
      <div class="news-dh">
        <span>发布时间：</span>
        <span>{{detailInfo.pubTime}}</span>
        <span class="line">|</span>
        <span>信息来源：</span>
        <span>{{detailInfo.infoSource}}</span>
      </div>
      <div class="news-content" v-html="detailInfo.content"></div>
      <!-- <ueditor v-model="detailInfo.content"></ueditor> -->
    </div>
  </div>
</template>

<script>
// import ueditor from "@/components/ueditor/index2"
import { indexNewsView } from "@/api/index.js";
export default {
  name: "newList",
  data() {
    return {
      title: "新闻政策详情",
      detailInfo: {}
    };
  },
  mounted() {
    if (this.$route.query.id) {
      indexNewsView(this.$route.query.id).then(res => {
        this.detailInfo = res.data
        //百度编辑器默认图片路径不对的问题
      });
    }
  },
  methods: {
    getList() {
    }
  }
};
</script>

<style>
.container {
  padding-bottom: 20px;
}
.headerImg {
  background-image: url("../../assets/news.png");
  min-width: 1200px;
  height: 180px;
}
.mainTitle {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #fff;
  text-shadow: 0 0 3px #3f93f6, 0 0 3px #3f93f6, 0 0 3px #3f93f6,
    0 0 3px #3f93f6;
}
.main {
  width: 1200px;
  min-height: calc(100vh - 421px);
  /* height: 1200px; */
  margin: 0px auto;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 30px;
}
.main-top {
  width: 1200px;
  margin: 0px auto;
  margin-top: 20px;
}
.news-dt {
  color: #5d5d5d;
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  padding-top: 20px;
  margin-bottom: 10px;
}
.news-dh {
  text-align: center;
  color: #999;
  line-height: 18px;
  font-size: 14px;
  margin-bottom: 30px;
}
.news-dh .line {
  margin: 0 10px;
  line-height: 18px;
}
.el-backtop {
  transform: scale(1.4);
}
.news-content {
    width: 100%;
}
.news-content img {
  max-width: 100%;  
}
</style>